import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text, TextInput } from '@/components/common/text';
import { useDesktopColors } from '@/constants/residents/desktop/color';

interface PaymentAmountInputProps {
  value: string;
  onChangeText: (text: string) => void;
  placeholder?: string;
  editable?: boolean;
  disabled?: boolean;
  style?: any;
  inputStyle?: any;
}

export const PaymentAmountInput: React.FC<PaymentAmountInputProps> = ({
  value,
  onChangeText,
  placeholder = '0.00',
  editable = true,
  disabled = false,
  style,
  inputStyle,
}) => {
  const DESKTOP_COLORS = useDesktopColors();
  return (
    <View style={[styles.amountInputWrap, style]}>
      <Text style={[styles.currencyPrefix, { color: DESKTOP_COLORS.TEXT_PRIMARY }, disabled && styles.disabledText]}>$</Text>
      <TextInput
        style={[
          styles.amountInput,
          { color: DESKTOP_COLORS.TEXT_PRIMARY, borderColor: DESKTOP_COLORS.BORDER_SECONDARY },
          disabled && styles.amountInputDisabled,
          inputStyle,
        ]}
        editable={editable && !disabled}
        keyboardType="decimal-pad"
        value={value}
        onChangeText={onChangeText}
        placeholder={placeholder}
        placeholderTextColor={DESKTOP_COLORS.TEXT_TERTIARY}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  amountInputWrap: {
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: 180,
    justifyContent: 'flex-end',
  },
  currencyPrefix: {
    marginRight: 6,
  },
  amountInput: {
    minWidth: 160,
    minHeight: 44,
    borderRadius: 10,
    borderWidth: 1,
    backgroundColor: 'transparent',
    paddingHorizontal: 12,
  },
  amountInputDisabled: {
    opacity: 0.4,
  },
  disabledText: {
    opacity: 0.4,
  },
});
